export default class BaseCommand {
  SessionId!: string;
  OperationId!: string;
  CommandName!: string;
  Command: unknown;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  AfterExecuteCallback?: (result: any) => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(sessionId: string, operationId: string, afterExecuteCallback?: (result: any) => void) {
    this.SessionId = sessionId;
    this.OperationId = operationId;
    this.AfterExecuteCallback = afterExecuteCallback;
  }
}
